import React from 'react';
import {withStyles} from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';

import i18n from '../../i18n';
import Layout from '../../components/Layout';
import Toolbar from "../../components/Toolbar/Toolbar";
import InnerAttributeForm from '../../components/Attribute/Form';

const AttributeForm = ({classes, attribute, attributeGroups, categoryOptions, intervalUnits, keys, units, rates}) => (
    <Layout>
        <Toolbar
            disableGutters
            title={i18n.get('attribute.title')}
        />

        <div className={classes.layout}>
            <Paper className={classes.paper}>
                {attribute ? (
                    /* Edit a already existing life cycle rate */
                    <InnerAttributeForm
                        method="PUT"
                        url={`/attributes/${attribute.id}`}
                        values={attribute}
                        attributeGroups={attributeGroups}
                        categoryOptions={categoryOptions}
                        intervalUnits={intervalUnits}
                        units={units}
                        rates={rates}
                        keys={keys}
                    />
                ) : (
                    /* Create a new life cycle rate */
                    <InnerAttributeForm
                        method="POST"
                        url="/attributes"
                        attributeGroups={attributeGroups}
                        categoryOptions={categoryOptions}
                        intervalUnits={intervalUnits}
                        units={units}
                        rates={rates}
                        keys={keys}
                    />
                )}
            </Paper>
        </div>
    </Layout>
);

const styles = theme => ({
    layout: {
        width: 'auto',
        marginLeft: theme.spacing.unit * 2,
        marginRight: theme.spacing.unit * 2,
        [theme.breakpoints.up(600 + theme.spacing.unit * 2 * 2)]: {
            width: 600,
            marginLeft: 'auto',
            marginRight: 'auto',
        },
    },
    paper: {
        marginBottom: theme.spacing.unit * 3,
        padding: theme.spacing.unit * 2,
        [theme.breakpoints.up(600 + theme.spacing.unit * 3 * 2)]: {
            marginBottom: theme.spacing.unit * 6,
            padding: theme.spacing.unit * 3,
        },
    },
});

export default withStyles(styles)(AttributeForm);
